"use strict";

import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { Coder } from "./abstract-coder";
import { pack, unpack } from "./array";
export var TupleCoder = /*#__PURE__*/function (_Coder) {
  _inherits(TupleCoder, _Coder);

  var _super = _createSuper(TupleCoder);

  function TupleCoder(coders, localName) {
    var _this;

    _classCallCheck(this, TupleCoder);

    var dynamic = false;
    var types = [];
    coders.forEach(function (coder) {
      if (coder.dynamic) {
        dynamic = true;
      }

      types.push(coder.type);
    });
    var type = "tuple(" + types.join(",") + ")";
    _this = _super.call(this, "tuple", type, localName, dynamic);
    _this.coders = coders;
    return _this;
  }

  _createClass(TupleCoder, [{
    key: "defaultValue",
    value: function defaultValue() {
      var values = [];
      this.coders.forEach(function (coder) {
        values.push(coder.defaultValue());
      }); // We only output named properties for uniquely named coders

      var uniqueNames = this.coders.reduce(function (accum, coder) {
        var name = coder.localName;

        if (name) {
          if (!accum[name]) {
            accum[name] = 0;
          }

          accum[name]++;
        }

        return accum;
      }, {}); // Add named values

      this.coders.forEach(function (coder, index) {
        var name = coder.localName;

        if (!name || uniqueNames[name] !== 1) {
          return;
        }

        if (name === "length") {
          name = "_length";
        }

        if (values[name] != null) {
          return;
        }

        values[name] = values[index];
      });
      return Object.freeze(values);
    }
  }, {
    key: "encode",
    value: function encode(writer, value) {
      return pack(writer, this.coders, value);
    }
  }, {
    key: "decode",
    value: function decode(reader) {
      return reader.coerce(this.name, unpack(reader, this.coders));
    }
  }]);

  return TupleCoder;
}(Coder);